import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OnBoardingStepProps } from '../../../type';
import OnBoardingStep from './on-boarding-step';
import { saveAiSeqGeneratorStepDetailsRequest } from '../../../../../extra-actions';
import { AiSequenceGeneratorSteps } from '../../../enums';
import { RootState } from '../../../../../../../store/root-reducer';

const OnBoardingStepContainer: React.FC<OnBoardingStepProps> = ({
  handleModalClose,
  addChatMessage,
}) => {
  const dispatch = useDispatch();

  const startAiSeqGeneratorProcess = () => {
    dispatch(
      saveAiSeqGeneratorStepDetailsRequest({
        stepName: AiSequenceGeneratorSteps.INITIATE_AI_SEQUENCE,
      }),
    );
  };

  const isProspectEnrichmentEnabledMeta = useSelector(
    (state: RootState) => state?.home?.isProspectEnrichmentEnabled,
  );
  const isOldAgencyUser = useSelector(
    (state: RootState) => state?.home?.isAgencyUser,
  );

  const stepRequestStatus = useSelector(
    (state: RootState) =>
      state?.sequence?.saveAiSeqGeneratorStepDetailsRequest?.status,
  );

  return (
    <OnBoardingStep
      handleModalClose={handleModalClose}
      startAiSeqGeneratorProcess={startAiSeqGeneratorProcess}
      addChatMessage={addChatMessage}
      stepRequestStatus={stepRequestStatus}
      isProspectEnrichmentEnabledMeta={isProspectEnrichmentEnabledMeta}
      isOldAgencyUser={isOldAgencyUser}
    />
  );
};

export default memo(OnBoardingStepContainer);
